//tick marks used in the component Favorite year for the slider
export const sliderticks = [
  {
    value: 1969,
    label: "Most Recent",
  },
  {
    value: 1970,
    label: "2020",
  },
  {
    value: 1980,
    label: "2010",
  },

  {
    value: 1990,
    label: "2000",
  },

  {
    value: 2000,
    label: "1990",
  },
  {
    value: 2010,
    label: "1980",
  },
  {
    value: 2020,
    label: "1970",
  },
];
